import { VALUATION_ENDPOINT } from "../resources/APP_CONSTANTS";
import { ValuationPayload, ValuationResponse } from "../types/apis";

export const getValuation = async (
  vehicleDetails: ValuationPayload,
  bearerToken: string,
): Promise<ValuationResponse> => {
  const valuationServiceUrl = process.env.REACT_APP_VALUATION_SERVICE_URL;

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearerToken}`,
    },
    body: JSON.stringify(vehicleDetails),
  };

  let response;

  try {
    response = await fetch(valuationServiceUrl + VALUATION_ENDPOINT, requestOptions);
  } catch (err) {
    throw new Error("Valuation failed due to fetch" + err);
  }
  const responseJson = await response.json();

  if (response.ok) {
    return responseJson;
  }

  throw new Error("Valuation lookup failed.");
};
